import React, { Fragment } from 'react'
import estilos from './MarcasMezcalComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';

function MarcasMezcalComponent(props) {

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 container2">
                        <div className={`${estilos.lista}`}>
                            <ol className={`${estilos.ol}`}>
                                <li className={`${estilos.li}`}>
                                    <div className={`${estilos.circulo}`}>
                                        <b style={{ width: '100%', textAlign: 'center' }}>{Number(props?.index) + 1}</b>
                                    </div>
                                    <div className={`${estilos.card}`} style={{ marginTop: '-10%' }}>
                                        <div className={props?.data?.isbaja ? `${estilos.cardHeaderBaja}` : `${estilos.cardHeader}`}>
                                            <h4 style={{ margin: 0 }}>MARCA: {props?.data?.marca?.toUpperCase()} </h4>
                                        </div>
                                        <div className={`${estilos.cardBody} row`}>
                                                <div className='row' style={{ margin: 0, padding: 0 }}>
                                                    <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}>
                                                        <label><b>Número de registro: <br /> </b> {props?.data?.numeroderegistroimpi?.toUpperCase()} </label> 
                                                        </div>
                                                    <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}>
                                                        <label><b>Tipo de marca: <br /> </b> {props?.data?.idtipomarca == 1 ? 'MIXTA' : props?.data?.idtipomarca == 2 ? 'NOMINATIVA' : props?.data?.idtipomarca == 3 ? 'TRIDIMENCIONAL' : ''} </label> 
                                                        </div>
                                                    <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Titularidad: <br /> </b>
                                                        {(props.data.idtitularidaddemarca == 1 ? 'Marca propia' :
                                                            props.data.idtitularidaddemarca == 2 ? 'Marca propia en trámite' :
                                                                props.data.idtitularidaddemarca == 3 ? 'Marca de licencia de uso autorizado' :
                                                                    props.data.idtitularidaddemarca == 4 ? 'Marca cesión de derechos autorizada' :
                                                                        props.data.idtitularidaddemarca == 5 ? 'Marca de licencia de uso en trámite' :
                                                                            props.data.idtitularidaddemarca == 6 ? 'Marca cesión de derechos en trámite' :
                                                                                '')?.toUpperCase()} </label>
                                                    </div>
                                                    {props?.data?.productor != '' && props?.data?.productor != null && props?.data?.productor != undefined &&
                                                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Productor: <br /> </b> {props?.data?.productor?.toUpperCase()} </label> </div>
                                                    }
                                                    {props?.data?.maquilador != '' && props?.data?.maquilador != null && props?.data?.maquilador != undefined &&
                                                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Maquilador: <br /> </b> {props?.data?.maquilador?.toUpperCase()} </label> </div>
                                                    }
                                                </div>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div >
                </div >
            </ThemeProvider >
        </Fragment >
    )
}

export default MarcasMezcalComponent